export default {
  /**
   * @description api请求基础路径
   */
  STOREID: process.env.VUE_APP_STOREID,
  
  PIC_URL:process.env.VUE_APP_PIC_URL,
  WHITE_LIST: ['Login', 'SignUp', 'ForgetPassword', 'GoodsDetail', 'Cart', 'PaySuccess'], // 不缓存白名单
  H5_LINK: process.env.VUE_APP_H5 + '/distributionh5/#/',
}